export default __webpack_public_path__ + "static/element_solutions-058fc4a17183f56ff119a62ab9d139a8.png";